import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import AuthLayout from '@/layouts/AuthLayout';
import LoginPage from '@/pages/login/LoginPage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import UserListPage from '@/pages/users/UserListPage';
import UserDetailPage from '@/pages/users/UserDetailPage';
import AnalyticsPage from '@/pages/analytics/AnalyticsPage';
import LLMCallLogPage from '@/pages/llm-calls/LLMCallLogPage';
import LLMModelsPage from '@/pages/llm-models/LLMModelsPage';
import ImageModelsPage from '@/pages/image-models/ImageModelsPage';
import ImageGenLogPage from '@/pages/image-gen-logs/ImageGenLogPage';
import StorageTestPage from '@/pages/storage-test/StorageTestPage';
import FeedbackPage from '@/pages/feedback/FeedbackPage';
import CreatorListPage from '@/pages/creators/CreatorListPage';
import CreatorDetailPage from '@/pages/creators/CreatorDetailPage';
import BundleReviewQueuePage from '@/pages/bundles/BundleReviewQueuePage';
import BundleDetailPage from '@/pages/bundles/BundleDetailPage';
import PurchaseExceptionsPage from '@/pages/exceptions/PurchaseExceptionsPage';
import MarketplaceSettingsPage from '@/pages/settings/MarketplaceSettingsPage';
import WithdrawalListPage from '@/pages/withdrawals/WithdrawalListPage';
import MarketplaceDashboardPage from '@/pages/marketplace/MarketplaceDashboardPage';

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<AuthLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UserListPage />} />
            <Route path="users/:id" element={<UserDetailPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="llm-calls" element={<LLMCallLogPage />} />
            <Route path="llm-models" element={<LLMModelsPage />} />
            <Route path="image-models" element={<ImageModelsPage />} />
            <Route path="image-gen-logs" element={<ImageGenLogPage />} />
            <Route path="storage-test" element={<StorageTestPage />} />
            <Route path="feedback" element={<FeedbackPage />} />
            <Route path="creators" element={<CreatorListPage />} />
            <Route path="creators/:id" element={<CreatorDetailPage />} />
            <Route path="bundles" element={<BundleReviewQueuePage />} />
            <Route path="bundles/:id" element={<BundleDetailPage />} />
            <Route path="exceptions" element={<PurchaseExceptionsPage />} />
            <Route path="marketplace-settings" element={<MarketplaceSettingsPage />} />
            <Route path="withdrawals" element={<WithdrawalListPage />} />
            <Route path="marketplace" element={<MarketplaceDashboardPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
